// extracted by mini-css-extract-plugin
export default {"companyInfo":"CompanyInfo_companyInfo__206qH"};